var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settingsProfile" } }, [
    _c("div", { staticClass: "name" }, [_vm._v("Profile")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-content" },
      [
        _c(
          "div",
          { staticClass: "text-field" },
          [
            _c("v-text-field", {
              ref: "inputFirstName",
              attrs: {
                "prepend-icon": "mdi-account",
                label: "First Name",
                rules: _vm.rules.firstName,
                "validate-on-blur":
                  _vm.$refs.inputFirstName && _vm.$refs.inputFirstName.valid
              },
              model: {
                value: _vm.user.firstName,
                callback: function($$v) {
                  _vm.$set(_vm.user, "firstName", $$v)
                },
                expression: "user.firstName"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-field" },
          [
            _c("v-text-field", {
              ref: "inputLastName",
              attrs: {
                "prepend-icon": "account-user",
                label: "Last Name",
                rules: _vm.rules.lastName,
                "validate-on-blur":
                  _vm.$refs.inputLastName && _vm.$refs.inputLastName.valid
              },
              model: {
                value: _vm.user.lastName,
                callback: function($$v) {
                  _vm.$set(_vm.user, "lastName", $$v)
                },
                expression: "user.lastName"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputPhone",
          attrs: {
            "prepend-icon": "phone",
            label: "Phone Number",
            rules: _vm.rules.phone,
            "validate-on-blur":
              _vm.$refs.inputPhone && _vm.$refs.inputPhone.valid
          },
          model: {
            value: _vm.user.phone,
            callback: function($$v) {
              _vm.$set(_vm.user, "phone", $$v)
            },
            expression: "user.phone"
          }
        }),
        _vm._v(" "),
        _c("v-select", {
          attrs: {
            items: _vm.colors,
            label: "Select",
            "item-text": "name",
            "item-value": "name",
            "single-line": "",
            auto: "",
            "return-object": "",
            "prepend-icon": "palette",
            "hide-details": ""
          },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function(data) {
                return _c("div", {}, [
                  _c("span", {
                    staticClass: "vo-color-circle",
                    style: { "background-color": _vm.getColor(data.item) }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "vo-color-name",
                      style: { color: _vm.getColor(data.item) }
                    },
                    [_vm._v(_vm._s(data.item.name))]
                  )
                ])
              }
            },
            {
              key: "selection",
              fn: function(data) {
                return _c("div", {}, [
                  _c("span", {
                    staticClass: "vo-color-circle",
                    style: { "background-color": _vm.getColor(data.item) }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "vo-color-name",
                      style: { color: _vm.getColor(data.item) }
                    },
                    [_vm._v(_vm._s(data.item.name))]
                  )
                ])
              }
            }
          ]),
          model: {
            value: _vm.user.color,
            callback: function($$v) {
              _vm.$set(_vm.user, "color", $$v)
            },
            expression: "user.color"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout, color: "primary", flat: "" },
            on: {
              click: function($event) {
                _vm.save()
              }
            }
          },
          [_vm._v("Save")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clear" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cb5df06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cb5df06","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsProfile.vue
// module id = 572
// module chunks = 4